var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapCulture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4465 15.4489C18.4465 23.9811 14.3171 30.8978 9.22323 30.8978C4.12938 30.8978 0 23.9811 0 15.4489C0 6.91671 4.12938 0 9.22323 0C14.3171 0 18.4465 6.91671 18.4465 15.4489Z",
    fill: "url(#paint0_radial_1694_26628)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.461422 16.372C0.461422 12.9336 2.93905 10.1463 5.99536 10.1463C9.05167 10.1463 11.5293 12.9336 11.5293 16.372C11.5293 19.8103 9.05167 22.5977 5.99536 22.5977C2.93905 22.5977 0.461421 19.8103 0.461422 16.372Z",
    fill: "url(#paint1_linear_1694_26628)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22331 16.371C9.22331 18.5359 7.57156 20.2909 5.53402 20.2909C3.49648 20.2909 1.84473 18.5359 1.84473 16.371C1.84473 14.2062 3.49648 12.4512 5.53402 12.4512C7.57156 12.4512 9.22331 14.2062 9.22331 16.371Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99536 11.2663C3.67796 11.2663 1.58139 13.4245 1.58139 16.372C1.58138 19.3194 3.67795 21.4777 5.99536 21.4777C8.31276 21.4777 10.4093 19.3194 10.4093 16.372C10.4093 13.4245 8.31276 11.2663 5.99536 11.2663ZM5.99536 10.1463C2.93905 10.1463 0.461422 12.9336 0.461422 16.372C0.461421 19.8103 2.93905 22.5977 5.99536 22.5977C9.05167 22.5977 11.5293 19.8103 11.5293 16.372C11.5293 12.9336 9.05167 10.1463 5.99536 10.1463Z",
    fill: "url(#paint2_linear_1694_26628)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67338 14.6205C4.30262 15.4093 3.49051 15.8082 2.85949 15.5116C2.22847 15.215 2.01749 14.3351 2.38825 13.5464C2.75901 12.7576 3.57111 12.3586 4.20213 12.6552C4.83315 12.9518 5.04414 13.8317 4.67338 14.6205Z",
    fill: "#FBF2C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1994 15.4489C39.1994 23.9811 35.07 30.8978 29.9762 30.8978C24.8823 30.8978 20.7529 23.9811 20.7529 15.4489C20.7529 6.91671 24.8823 0 29.9762 0C35.07 0 39.1994 6.91671 39.1994 15.4489Z",
    fill: "url(#paint3_radial_1694_26628)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2144 16.372C21.2144 12.9336 23.692 10.1463 26.7483 10.1463C29.8046 10.1463 32.2822 12.9336 32.2822 16.372C32.2822 19.8103 29.8046 22.5977 26.7483 22.5977C23.692 22.5977 21.2144 19.8103 21.2144 16.372Z",
    fill: "url(#paint4_linear_1694_26628)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7483 11.2663C24.4309 11.2663 22.3343 13.4245 22.3343 16.372C22.3343 19.3194 24.4309 21.4777 26.7483 21.4777C29.0657 21.4777 31.1623 19.3194 31.1623 16.372C31.1623 13.4245 29.0657 11.2663 26.7483 11.2663ZM26.7483 10.1463C23.692 10.1463 21.2144 12.9336 21.2144 16.372C21.2144 19.8103 23.692 22.5977 26.7483 22.5977C29.8046 22.5977 32.2822 19.8103 32.2822 16.372C32.2822 12.9336 29.8046 10.1463 26.7483 10.1463Z",
    fill: "url(#paint5_linear_1694_26628)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9762 16.371C29.9762 18.5359 28.3245 20.2909 26.2869 20.2909C24.2494 20.2909 22.5977 18.5359 22.5977 16.371C22.5977 14.2062 24.2494 12.4512 26.2869 12.4512C28.3245 12.4512 29.9762 14.2062 29.9762 16.371Z",
    fill: "#262626"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4263 14.6205C25.0555 15.4093 24.2434 15.8082 23.6124 15.5116C22.9814 15.215 22.7704 14.3351 23.1412 13.5464C23.5119 12.7576 24.324 12.3586 24.9551 12.6552C25.5861 12.9518 25.7971 13.8317 25.4263 14.6205Z",
    fill: "#FBF2C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1694_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.22323 15.4489) rotate(90) scale(15.4489 9.22323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1694_26628",
    x1: 5.99536,
    y1: 22.5977,
    x2: 5.99536,
    y2: 10.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1694_26628",
    x1: 5.99536,
    y1: 22.5977,
    x2: 5.99536,
    y2: 10.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1694_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9762 15.4489) rotate(90) scale(15.4489 9.22323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1694_26628",
    x1: 26.7483,
    y1: 22.5977,
    x2: 26.7483,
    y2: 10.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1694_26628",
    x1: 26.7483,
    y1: 22.5977,
    x2: 26.7483,
    y2: 10.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapCulture);
export default __webpack_public_path__ + "static/media/roadmap_culture.1ab77f3c99de40fac150a82e34635c5d.svg";
export { ForwardRef as ReactComponent };